import axios from 'axios';

const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL;
const baseUrlFlow = process.env.REACT_APP_AWS_API_GATEWAY_URL_EXECUTE_FLOW;

export const createContact = async (accessToken, payload) =>{
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'marketing_whatsapp_alter',
            'action': 'INSERT_CONTACT',
            'variables': JSON.stringify(payload)
        })
    })
};

export const editContactName = async (accessToken, payload) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'marketing_whatsapp_alter',
            'action': 'EDIT_CONTACT',
            'variables': JSON.stringify(payload)
        })
    })
};

export const getTemplates = async (accessToken, idCompany) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'marketing_whatsapp_templates_select',
            'action': 'SELECT_TEMPLATES',
            'variables': JSON.stringify({id_company: idCompany})
        })
    });
};

export const getStateUser = async (accessToken) => {
  return axios({
    method: 'POST',
    url: baseUrl,
    headers: {
      'Authorization': `Bearer ${accessToken}`
    },
    data: JSON.stringify({
      'process': 'user_select',
      'action': 'SELECT_STATE_WHATSAPP',
      'variables': '{}'
    })
  });
};

export const getUsers = async (id_company, accessToken) => {
  return axios({
    method: 'POST',
    url: baseUrl,
    headers: {
      'Authorization': `Bearer ${accessToken}`
    },
    data: JSON.stringify({
      'process': 'user_select',
      'action': 'GET_USERS_WHATSAPP',
      'variables': JSON.stringify({id_company})
    })
  });
};
export const updateContactResponsable = async (data, accessToken) => {
  return axios({
    method: 'POST',
    url: baseUrl,
    headers: {
      'Authorization': `Bearer ${accessToken}`
    },
    data: JSON.stringify({
      'process': 'marketing_whatsapp_alter',
      'action': 'UPDATE_RESPONSABLE',
      'variables': JSON.stringify(data)
    })
  });
};

export const updateUserStatusWhatsApp = async (accessToken, state) => {
  return axios({
    method: 'POST',
    url: baseUrl,
    headers: {
      'Authorization': `Bearer ${accessToken}`
    },
    data: JSON.stringify({
      'process': 'user_alter',
      'action': 'UPDATE_STATE_WHATSAPP',
      'variables': JSON.stringify({state})
    })
  });
};

export const sendEmailNotification = (contact, responsable, userSession) => {
  return axios({
        method: 'POST',
        url: baseUrlFlow,
        headers: {
            'Authorization': `Bearer ${userSession.token}`
        },
        data: JSON.stringify({
            'id_flow': '900114098-API-SEND-EMAIL',
            emailSource: responsable.user_name,
            responsableEmail: responsable.name, 
            contactName: contact.name,
            contactCellphone: contact.cellphone,
            assigner: userSession.user_name
        })
    })
};


export const sendRequest = async (accessToken, payload) => {
  return axios.post(baseUrlFlow, JSON.stringify(payload), {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    }
  });
};

export const getContacts = (byUser, accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'marketing_whatsapp_select',
            'action': 'SELECT_CONTACT',
            'variables': JSON.stringify({byUser:byUser})
        })
    })
};

export const getInitialMessages = (accessToken, id_marketing_whatsapp) => {
  return axios({
        method: 'POST',
        url: baseUrlFlow,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'id_flow': '900114098-GET-MESSAGE-DATABASE',
            'id_marketing_whatsapp': id_marketing_whatsapp
        })
    })
};

export const buildContent = ({ type, value, name, mimeType, animated, chatSelected, idCompany }) => {
  switch (type) {
    case 'text':
      return { body: value };
    case 'document':
    case 'image':
    case 'sticker':
    case 'video':
      return {
        filename: name,
        caption: type !== 'sticker' ? '': undefined,
        mime_type: mimeType,
        ...(type === 'sticker' && {
           animated:animated
        })
      };
    case 'template':
      return { 
          id_flow:  "900114098-INSERT-MESSAGE-TEMPLATE-AI",
          type,
          template_name: name,
          id_company: idCompany,
          id_marketing_template: value.id_marketing_template,
          id_marketing_whatsapp: chatSelected.id_marketing_whatsapp,
          cellphone: chatSelected.cellphone,
          session_id: chatSelected.cellphone,
          language: value.language_code,
          components: value.components,
          completed_components: value.completed_components
      }
    default:
      return value
  }
};

export const createWebhookPayload = ({ wa_id, type, content, value, chatSelected, idCompany }) => {
  const timestamp = Math.floor(Date.now() / 1000);
  const id = `wamid.${timestamp}`;

  const message = {
      from: wa_id,
      id,
      timestamp: `${timestamp}`,
      type,
      [type]: content
  };

  return {
    id_flow: "900114098-INSERT-MESSAGE-DIRECT-AI" ,
    cellphone: chatSelected.cellphone,
    id_marketing_whatsapp: chatSelected.id_marketing_whatsapp,
    message: type === "text" ? content.body : undefined,
    type,
    ...(type !== "text" && {
      attachmentsProcess: {
        Base64: value,
        LocalPath: '{"bucket":"","path":"", "localPath":""}',
        Name: content.filename,
        Extension: content.filename?.split('.').pop()?.toLowerCase() || '',
      },
      mime_type: content.mime_type || null,
    }),
    ...(type === "document" && {
      filename: content.filename
    }),
    id_company: idCompany,
    response: {
      object: "whatsapp_business_account",
      entry: [
        {
          id: Date.now(),
          changes: [
            {
              field: "messages",
              value: {
                messaging_product: "whatsapp",
                metadata: {
                  display_phone_number: "573011595605",
                  phone_number_id: "515728491634856"
                },
                contacts: [
                  {
                    profile: { name: chatSelected.name || "Contacto" },
                    wa_id
                  }
                ],
                messages: [message]
              }
            }
          ]
        }
      ]
    }
  };
};

